import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "components/ui/dialog";
import { Button } from "components/ui/button";

interface ConfirmDialogProps {
  open: boolean;
  title: React.ReactNode;
  content: React.ReactNode;
  cancelText: React.ReactNode;
  confirmText: React.ReactNode;
  /** Called on any dismissal: cancel button, Escape, or a click on the backdrop. */
  onClose: () => void;
  /** Called when the confirm button is pressed. Does not close the dialog by itself. */
  onConfirm: () => void;
}

/**
 * Shared confirm dialog for the booking flows, backed by the Radix dialog
 * primitive. Unlike the legacy MUI dialogs it can safely open inside the
 * non-modal FullScreenDialog without competing focus traps (#1299).
 */
const ConfirmDialog = (props: ConfirmDialogProps) => {
  const handleOpenChange = (next: boolean) => {
    if (!next) props.onClose();
  };

  return (
    <Dialog open={props.open} onOpenChange={handleOpenChange}>
      <DialogContent
        showCloseButton={false}
        className="max-w-[calc(100vw-4rem)] sm:max-w-sm"
      >
        <DialogTitle>{props.title}</DialogTitle>
        <DialogDescription className="mt-2">{props.content}</DialogDescription>
        <div className="mt-6 flex justify-end gap-3">
          <Button variant="outline" onClick={props.onClose}>
            {props.cancelText}
          </Button>
          <Button variant="primary" onClick={props.onConfirm}>
            {props.confirmText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
